import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import {Md5} from 'ts-md5/dist/md5';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Rx';
import { GlobalVariable } from '../global';
import { LoginService } from '../services/login.service';
import {Observable} from "rxjs/Observable";
@Injectable()

export class AdminService{

   // BASE_URL = 'http://localhost:1234';
    private BASE_URL = GlobalVariable.BASE_URL; 
   
    

    constructor( private http : Http ,private router: Router, private ls : LoginService){}
  getUser() {
        return this.http.get(this.BASE_URL + '/admin/users', this.ls.tokenHeader).map(res => res.json());
    }

  /* getUser(): Observable<IPosts[]> {
        return this.http
            .get(this.BASE_URL + '/admin/users',this.ls.tokenHeader)
            .map(res => {
                return <IPosts[]>res.json().users;
            })
          
    }

    private handleError(error: Response) {
        return Observable.throw(error.statusText);
    }*/

    getParticularUser(emplyoeeCodeData)
    {
    
        return this.http.post(this.BASE_URL + '/admin/partiUser',emplyoeeCodeData, this.ls.tokenHeader).map(res => res.json());
    }
    particularUserRoleSet(sendUserData)
    {
    
        return this.http.post(this.BASE_URL + '/admin/partiUserRoleSet',sendUserData, this.ls.tokenHeader).map(res => res.json());
    }
    setAdminPwd(userData)
    {
        
        userData.password = Md5.hashStr(userData.password);
       return this.http.post( this.BASE_URL + '/admin/admin_change_password', userData,this.ls.tokenHeader).map(res => res.json());
    }
   

}


// WEBPACK FOOTER //
// ./src/app/services/admin.service.ts